import { DialogStyles } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
export const styles = css `
  ${DialogStyles}
  dialog {
    max-width: var(--dialog-max-width, 600px);
  }
}`;
//# sourceMappingURL=dialog.styles.js.map